import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { DealFlag } from 'app/models/dto/team-deal';
import { DealFlagService } from './../../services/deal-flag/deal-flag.service';
import { EntityState, EntityStateModel } from '../entity/entity.state';
import { DealFlagActions as DA } from './deal-flag.action';

// Inherit the parent state model with correct entity type.
export class DealFlagStateModel extends EntityStateModel<DealFlag>{}

@State<DealFlagStateModel>({
	name: 'dealFlag',
	defaults: {
    entities: [],
    current: null,
    expires: 0
  }
})

@Injectable()
export class DealFlagState extends EntityState<DealFlag> {

  // DI creates a concrete service that implements AbstractCrudService for
  // use by the parent EntityState.
	constructor(
    private concreteEntityService: DealFlagService,
  ) {
    super(
      concreteEntityService,
      // Optional expiresIn argument as `(5 * 60 * 1000)`. 5 minute default.
    );
  }

  // If you only need generic CRUD action, just wrap the parent actions.
  // Or you can implement additional stuff specific to this store using its
  // actions.ts file.
  @Action(DA.Create)
	create(ctx: StateContext<DealFlagStateModel>, payload: DA.Create) {
    return super.create(ctx, payload);
  }

  @Action(DA.Delete)
	delete(ctx: StateContext<DealFlagStateModel>, payload: DA.Delete) {
    return super.delete(ctx, payload);
  }
}
